//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.FaceMillingBuilder.js";
import "../CAM/CAM.Geometry.js";
import "../CAM/CAM.InheritableToolDepBuilder.js";
import "../CAM/CAM.InheritableDoubleBuilder.js";
let d=[[[1,"BlankGeometry",0,"CAM.Geometry",0],[0,"CutDepths",1,0],[0,"ExtendWalls",1,0],[0,"FollowNonVerticalWalls",1,0],[1,"TopOffset",0,"CAM.InheritableToolDepBuilder",0],[0,"UseCleanupPass",1,0],[0,"UseExactPositioning",1,0],[1,"WallBlankThickness",0,"CAM.InheritableDoubleBuilder",0],[1,"ZDepthOffset",0,"CAM.InheritableDoubleBuilder",0]],[],[]];
SPLM.CAM.VolumeBased25DMillingOperationBuilder = class extends SPLM.CAM.FaceMillingBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.VolumeBased25DMillingOperationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.VolumeBased25DMillingOperationBuilder.CutDepthsType = Object.freeze({
    "Levels" : "Levels", "RampByDepth" : "RampByDepth", "RampByAngle" : "RampByAngle"});

export default SPLM;